import React from 'react';
import { Icon } from '@iconify/react';
import shieldFill from '@iconify/icons-eva/shield-fill';
// routes
import { PATH_DASHBOARD, PATH_ADMIN } from '../../routes/paths';
// components
import SvgIconStyle from '../../components/SvgIconStyle';
// hooks
import useLocales from '../../hooks/useLocales';

// ----------------------------------------------------------------------

const getIcon = (name, ext) => (
  ext === 'svg' ? (
    <SvgIconStyle src={`/static/icons/navbar/${name}.${ext}`} sx={{ width: '100%', height: '100%' }} />
  ) : (
    <img src={`/static/icons/navbar/${name}.${ext}`} alt={name} style={{ width: 'auto', height: '100%' }} />
  )
);



const ICONS = {
  user: getIcon('ic_user', 'svg'),
  decks: getIcon('ic_deck', 'png'),
  dashboard: getIcon('ic_dashboard', 'svg'),
  home: getIcon('ic_home', 'png'),
  progress: getIcon('ic_progress', 'png'),
};

export function useConfig (){
  const { translate } = useLocales();

  const userSidebarConfig = [
    {
      subheader: translate('nav.study'),
      items: [
        { title: translate('nav.home'), path: PATH_DASHBOARD.root, icon: ICONS.home, end: true },
        
        { title: translate('nav.myDecks'), path: PATH_DASHBOARD.decks.root, icon: ICONS.decks },
        { title: translate('nav.progress'), path: PATH_DASHBOARD.progress, icon: ICONS.progress },
      ]
    },
  ];

  const adminSidebarConfig = [
    ...userSidebarConfig,
    {
      subheader: translate('nav.admin'),
      items: [
        {
          title: translate('nav.adminPanel'),
          path: PATH_ADMIN.root,
          icon: <Icon icon={shieldFill} width={22} height={22} />,
        },
      ],
    },
  ];

  return { adminSidebarConfig, userSidebarConfig }
}
